"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
exports.WINDOW_REF = new core_1.InjectionToken('WindowRefToken');
function browserWindowFactory(platformId) {
    if (common_1.isPlatformBrowser(platformId)) {
        return window;
    }
    return {};
}
exports.browserWindowFactory = browserWindowFactory;
exports.windowRefProvider = {
    provide: exports.WINDOW_REF,
    useFactory: browserWindowFactory,
    deps: [core_1.PLATFORM_ID]
};
// This wrapper is needed because Angular compile fails when trying to use the Window class as a type
// Window is an interface and Angular doesn't like trying to inject that (only affects prod mode compile)
var WindowWrapper = /** @class */ (function (_super) {
    __extends(WindowWrapper, _super);
    function WindowWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WindowWrapper;
}(Window));
exports.WindowWrapper = WindowWrapper;
